import { render, staticRenderFns } from "./WidgetSelect.vue?vue&type=template&id=1d7b7362&lang=pug"
import script from "./WidgetSelect.vue?vue&type=script&lang=js"
export * from "./WidgetSelect.vue?vue&type=script&lang=js"
import style0 from "./WidgetSelect.vue?vue&type=style&index=0&id=1d7b7362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCombobox,VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle,VSelect,VTextField})
